import * as React from "react";
import Modal from "./Modal";
import ModalHeader from "./ModalHeader";
import ModalBody from "./ModalBody";
import ModalFooter from "./ModalFooter";
import Button from "./Button";
import useConfig from "../hooks/useConfig";

interface Props {
  onClickYes: () => void;
  onClickNo: () => void;
}

export default function CloseChatModal(props: Props) {
  const config = useConfig();
  return (
    <Modal>
      <ModalHeader>{config.CloseChatHeaderText}</ModalHeader>
      <ModalBody>{config.CloseChatConfirmationText}</ModalBody>
      <ModalFooter>
        <Button variant="primary" autoFocus={true} onClick={props.onClickYes}>
          {config.YesButtonText}
        </Button>
        <Button variant="secondary" onClick={props.onClickNo}>
          {config.NoButtonText}
        </Button>
      </ModalFooter>
    </Modal>
  );
}
